@if (component) {
<div [style.display]="'grid'"
     [gridColumnGap]="component.gap"
     [grid]="12">
    @for (column of columns; track $index) {
    <icms-outlet [name]="'Column'"
                 [gridColumn]="column.size"
                 [fullHeight]="true"
                 [components]="column.components">
    </icms-outlet>
    }
</div>
}